import { Record } from 'immutable';
import remove from 'lodash/fp/remove';
import * as types from './actionTypes';
import constants from '../constants';

const requestReducerState = Record({
  feedMappings: [],
  feedMapping: {
    id: null,
  },
  [constants.ERROR_KEY]: null,
  [constants.SUCCESS_KEY]: null,
  [constants.FETCHING_KEY]: false,
});

export default (state = requestReducerState(), action) => {
  const { type, payload } = action;
  switch (type) {
    case types.FEED_MAPPINGS_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('feedMappings', payload);
    case types.FEED_MAPPING_SUCCESS:
    case types.CREATE_FEED_MAPPING_SUCCESS:
    case types.UPDATE_FEED_MAPPING_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('feedMapping', payload);
    case types.DELETE_FEED_MAPPING_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('feedMappings', remove({ id: payload })(state.feedMappings));
    case types.FEED_MAPPINGS_REQUEST:
    case types.FEED_MAPPING_REQUEST:
    case types.CREATE_FEED_MAPPING_REQUEST:
    case types.UPDATE_FEED_MAPPING_REQUEST:
    case types.DELETE_FEED_MAPPING_REQUEST:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, true);
    case types.FEED_MAPPINGS_FAILURE:
    case types.FEED_MAPPING_FAILURE:
    case types.CREATE_FEED_MAPPING_FAILURE:
    case types.UPDATE_FEED_MAPPING_FAILURE:
    case types.DELETE_FEED_MAPPING_FAILURE:
      return state
        .set(constants.FETCHING_KEY, false)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.ERROR_KEY, action.payload);
    case types.RESET_FEED_MAPPING:
      return state.set('feedMapping', requestReducerState().feedMapping);
    default:
      return state;
  }
};
